module.exports = "<div class=\"side-mobile-toggle\">\n  <div class=\"button\" (click)=\"toggle()\" l10nTranslate>\n    <span id=\"side-bar-info\" type=\"button\" class=\"button-text\">INFO</span>\n    <alg-icon *ngIf=\"!isOpen\" class=\"button-icon\" icon=\"arrow-down\"></alg-icon>\n    <alg-icon *ngIf=\"isOpen\" class=\"button-icon\" icon=\"close\"></alg-icon>\n  </div>\n</div>\n<div class=\"sidebar-container\">\n  <div class=\"wrap-content\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alg-sidebar/alg-sidebar.component.html
// module id = ./src/app/components/alg-sidebar/alg-sidebar.component.html
// module chunks = main